import { AgentScope } from "@albertine/claims";
import { Tenant } from "albertine-shared-web";
import { z } from "zod";

export const PermissionGroupDoc = z.object({
    name: z.string(),
    agentScopes: z.array(AgentScope),

    /**
     * Tenants that members of this permission group may access. "*" means all tenants.
     * These are combined with the `agentScopes` to determine the permissions of the agent.
     */
    tenants: z.array(Tenant.or(z.literal("*"))),
});

export type PermissionGroupDoc = z.infer<typeof PermissionGroupDoc>;

export const PermissionGroup = PermissionGroupDoc.extend(
    z.object({ id: z.string() }).shape,
);

export type PermissionGroup = z.infer<typeof PermissionGroup>;

export { AgentScope, scopeAllowed, tenantAllowed } from "@albertine/claims";
